import {Link, LinkProps} from '@mui/material';
import React from 'react';

// Wrapper for MUI <Link> that adds secure target="_blank"
export const ExternalLink: React.FC<LinkProps> = React.forwardRef(
  (linkProps, ref) => (
    <Link {...linkProps} ref={ref} target="_blank" rel="noopener noreferrer" />
  )
);
